import React from "react";
import classes from "./Ramadan.module.css";
const Ramadan = () => {
  return (
    <div className={classes.ramadndiv}>
      <p>This schedule is only applicable during the holy month of Ramadan.</p>
      <p style={{ direction: "rtl" }}>
        يسري هذا الجدول فقط خلال شهر رمضان المبارك.
      </p>
    </div>
  );
};

export default Ramadan;
